export default "__VITE_ASSET__CRZ7gWCT__"